import { Button, Grid, Tooltip } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { ControlPoint, Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import CommonButton from "app/common/Component/Button/CommonButton";
import { pagingHealthCareRoom } from "app/services/HealthCareRoomService";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { SERVICE_REQUEST_STATUS } from "app/common/LocalConst";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";

const SearchTreatment = ({ isOpenFillter }) => {
  const { handleOpenUncompletedServicePopup } =
    useStore().patientManagementStore.uncompletedRegisterServiceStore;

  const { values } = useFormikContext();

  return (
    <>
      {!isOpenFillter && (
        <>
          <style>
            {`
                @keyframes slideDownFade {
                  0% {
                    opacity: 0;
                    transform: translateY(-10px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `}
          </style>
          <div
            style={{
              animation: "slideDownFade 0.3s ease forwards",
              zIndex: 10,
              position: "relative",
            }}
          >
            <Grid container spacing={1} className="cards-body">
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsMultiDatePicker 
                  label="Thời gian chỉ định từ ngày - đến ngày" 
                  name="orderDateFrom"
                  range
                  rangeHover
                  fromField="orderDateFrom"
                  toField="orderDateTo"
                  // format={"DD/MM/YYYY"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsMultiDatePicker 
                  label="Thời gian thực hiện từ ngày - đến ngày" 
                  name="performDateFrom"
                  range
                  rangeHover
                  fromField="performDateFrom"
                  toField="performDateTo"
                  // format={"DD/MM/YYYY"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={"department"}
                  label={"Cơ sở"}
                  api={pagingDepartment}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={"room"}
                  label={"Phòng"}
                  searchObject={{
                    departmentId: values?.department?.id,
                  }}
                  api={pagingHealthCareRoom}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={"healthCareSv"}
                  label={"Dịch vụ"}
                  api={pagingHealthCareService}
                  searchOject
                  searchObject={{
                    isUsing: true
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsSelectInput
                  name={"healthCareSv"}
                  label={"Trạng thái"}
                  options={SERVICE_REQUEST_STATUS}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={"auto"}
                className="flex flex-end gap-2"
              >
                <Button className="btn-primary" type="submit">
                  <Search />
                  Tìm kiếm
                </Button>
                {/* <Tooltip
                  arrow
                  placement="top"
                  title="Chỉ định thực hiện dịch vụ"
                >
                  <CommonButton
                    className="btn-add"
                    onClick={() => {
                      handleOpenUncompletedServicePopup();
                    }}fUncompletedServicePopup
                  >
                    <ControlPoint />
                    <span className="ml-1">
                      Chỉ định
                    </span>
                  </CommonButton>

                </Tooltip> */}
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default memo(observer(SearchTreatment));
